import type { EmcProductComplianceFileView } from '@/shared/hooks/api/emcComplianceFiles'
import {
  useCompleteEmcProductComplianceFile,
  useUncompleteEmcProductComplianceFile,
} from '@/shared/hooks/api/emcComplianceFiles'
import { ProductComplianceFileSignOffActions } from '@/v2/components/product-compliance-briefing/ProductComplianceFileSignOffActions'
import { hasConfirmedEmcStandardsForSignOff } from '@/v2/lib/emcProductComplianceFileDeclarationOfConformityRequirements'
import type { EmcBriefingStep } from '../../utils/emcLegislationBriefing'
import { V2EmcLegislationBriefingStepShell } from './V2EmcLegislationBriefingStepShell'

export function V2EmcProductSignOffStep({
  step,
  index,
  productId,
  productFile,
}: {
  step: EmcBriefingStep
  index: number
  productId: string
  productFile: EmcProductComplianceFileView | null
}) {
  const { mutateAsync: completeFile, isPending: isCompleting } =
    useCompleteEmcProductComplianceFile(productId)
  const { mutateAsync: uncompleteFile, isPending: isUncompleting } =
    useUncompleteEmcProductComplianceFile(productId)

  return (
    <V2EmcLegislationBriefingStepShell
      step={step}
      index={index}
      actions={
        productFile != null ? (
          <ProductComplianceFileSignOffActions
            productFile={productFile}
            canComplete={hasConfirmedEmcStandardsForSignOff(productFile)}
            isPending={isCompleting || isUncompleting}
            i18nKeyPrefix='v2.pages.products.detail.emcFiles'
            onComplete={completeFile}
            onUncomplete={uncompleteFile}
          />
        ) : undefined
      }
    />
  )
}
